module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-early-01-39fe837a92c6f47496b1477c65722f74.svg";